import React, { useState } from "react";
import Button from "./Button";
import { ArrowDown2, ArrowUp2 } from "iconsax-react";
import { AnimatePresence, motion as m } from "framer-motion";

const Grouping = ({ name, children }) => {
  const [isOpen, setIsOpen] = useState(true);

  const handleToggle = (e) => {
    e.preventDefault();
    setIsOpen(!isOpen);
  };

  return (
    <div className="flex w-full flex-col gap-[4px]">
      <Button
        variant="sidebar_grouping"
        className="w-full text-start"
        onClick={handleToggle}
      >
        {name}
        {isOpen ? (
          <ArrowUp2 size="18" color="#697689" />
        ) : (
          <ArrowDown2 size="18" color="#697689" />
        )}
      </Button>
      <AnimatePresence>
        {isOpen && children ? (
          <m.div
            style={{ overflow: "hidden" }}
            initial={{ height: 0 }}
            animate={{ height: "auto" }}
            exit={{ height: 0 }}
            transition={{ duration: 0.3 }}
          >
            {children}
          </m.div>
        ) : null}
      </AnimatePresence>
    </div>
  );
};

export default Grouping;
